const BACKGROUND_IDENTIFICATION_TYPE =
  'Works::Onboarding::WorksListItemTypes::BackgroundIdentification';
const IMMIGRATION_TYPE = 'Works::Onboarding::WorksListItemTypes::Immigration';
const LICENSE_TYPE = 'Works::Onboarding::WorksListItemTypes::License';
const CERTIFICATION_TYPE =
  'Works::Onboarding::WorksListItemTypes::Certification';
const ASESSMENT_TYPE = 'Works::Onboarding::WorksListItemTypes::Assessment';
const HEALTH_DOC = 'Works::Onboarding::WorksListItemTypes::HealthDocument';
const OTHER_DOCUMENT = 'Works::Onboarding::WorksListItemTypes::OtherDocument';

export {
  BACKGROUND_IDENTIFICATION_TYPE,
  IMMIGRATION_TYPE,
  LICENSE_TYPE,
  CERTIFICATION_TYPE,
  ASESSMENT_TYPE,
  HEALTH_DOC,
  OTHER_DOCUMENT,
};
